import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const keepFileToken = (d) => { if (d?.file_token) localStorage.setItem("file_token", d.file_token); };

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=user
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // If returning from Google OAuth, let AuthCallback exchange the session first.
    if (window.location.hash?.includes("session_id=")) {
      setReady(true);
      return;
    }
    const token = localStorage.getItem("token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => { keepFileToken(r.data); setUser(r.data); })
      .catch(() => {
        localStorage.removeItem("token");
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const persist = (data) => {
    localStorage.setItem("token", data.access_token);
    keepFileToken(data);
    setUser(data.user);
  };

  const loginWithData = (data) => {
    persist(data);
    setReady(true);
    return data.user;
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.requires_2fa) return data; // caller shows the 2FA step
    persist(data);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    persist(data);
    return data.user;
  };

  const logout = () => {
    ["token", "file_token", "workspace_id"].forEach((k) => localStorage.removeItem(k));
    setUser(false);
  };

  const refreshUser = async () => {
    const { data } = await api.get("/auth/me");
    keepFileToken(data);
    setUser(data);
    return data;
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, register, logout, setUser, refreshUser, loginWithData }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
